// Preserve click order across asynchronous authorization. Digits stay in memory
// only and are never replayed after a call, leg, permission or media-state change.
export function createDtmfDispatcher({capture,current,authorize,send,pendingChanged=()=>{},maxPending=32,maxAge=5000,clock=()=>Date.now()}){
 let tail=Promise.resolve(),revision=0,pending=0;
 const cancel=()=>{revision++;};
 function enqueue(digit){
  if(!/^[0-9*#]$/.test(digit))return Promise.reject(Error('Invalid keypad digit'));
  if(pending>=maxPending)return Promise.reject(Error('Keypad is busy; wait before entering more digits'));
  const target=capture(),version=revision,started=clock();
  if(!target)return Promise.reject(Error('No phone call is ready for keypad input'));
  pending++;pendingChanged(target,1);
  const check=()=>{
   if(version!==revision||!current(target))throw Error('Pending keypad input cancelled because the call or its controls changed. Enter the PIN again only when prompted.');
   if(clock()-started>=maxAge)throw Error('Keypad approval timed out; pending input was cancelled. Check the portal connection before trying again.');
  };
  const job=tail.then(async()=>{
   check();let timer;
   try{await Promise.race([authorize(target),new Promise((_,reject)=>{timer=setTimeout(()=>reject(Error('Keypad approval timed out; pending input was cancelled. Check the portal connection before trying again.')),Math.max(1,maxAge-(clock()-started)));})]);}
   finally{clearTimeout(timer);}
   check();send(digit,target);
  }).catch(error=>{if(version===revision)cancel();throw error;}).finally(()=>{pending--;pendingChanged(target,-1);});
  tail=job.catch(()=>{});
  return job;
 }
 return {enqueue,cancel};
}
